import React from 'react'

type HintIconProps = {
	size?: number
	color?: string
	filled?: boolean
}

export const HintIcon: React.FC<HintIconProps> = ({
	size = 16,
	color = 'currentColor',
	filled = false,
}) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		{filled ? (
			<>
				<path
					d="M8 1C5.23858 1 3 3.23858 3 6C3 7.64373 3.77685 9.10673 5 10.0385V12C5 12.5523 5.44772 13 6 13H10C10.5523 13 11 12.5523 11 12V10.0385C12.2231 9.10673 13 7.64373 13 6C13 3.23858 10.7614 1 8 1Z"
					fill={color}
				/>
				<path
					d="M6 14.5H10"
					stroke={color}
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
			</>
		) : (
			<>
				<path
					d="M8 1C5.23858 1 3 3.23858 3 6C3 7.64373 3.77685 9.10673 5 10.0385V12C5 12.5523 5.44772 13 6 13H10C10.5523 13 11 12.5523 11 12V10.0385C12.2231 9.10673 13 7.64373 13 6C13 3.23858 10.7614 1 8 1Z"
					stroke={color}
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M6 14.5H10"
					stroke={color}
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
				<path
					d="M8 4V6.5"
					stroke={color}
					strokeWidth="1.5"
					strokeLinecap="round"
				/>
				<circle cx="8" cy="8.5" r="0.75" fill={color} />
			</>
		)}
	</svg>
)
